<span class="text-xs lg:text-base font-bold tema-color" [class]="classes">{{ days || days > 0 ? days + ' dia(s)' : '' }} {{ countdown }}</span>